export const SIU_REQUIRED_MESSAGE = 'This field is required.';

export type SiuCaseDetailsFieldErrors = {
    allegedInjury?: string;
    restrictions?: string;
};

export type SiuCaseDetailsValidationState = {
    allegedInjury: string;
    restrictions: string;
};

const FIELD_LABELS: Record<keyof SiuCaseDetailsFieldErrors, string> = {
    allegedInjury: 'Alleged Injury',
    restrictions: 'Restrictions',
};

export function validateSiuCaseDetailsFields(state: SiuCaseDetailsValidationState): SiuCaseDetailsFieldErrors {
    const errors: SiuCaseDetailsFieldErrors = {};

    if (!state.allegedInjury?.trim()) {
        errors.allegedInjury = SIU_REQUIRED_MESSAGE;
    }

    if (!state.restrictions?.trim()) {
        errors.restrictions = SIU_REQUIRED_MESSAGE;
    }

    return errors;
}

export function isSiuCaseDetailsFormValid(errors: SiuCaseDetailsFieldErrors): boolean {
    return Object.keys(errors).length === 0;
}

export function getSiuCaseDetailsMissingFieldLabels(errors: SiuCaseDetailsFieldErrors): string[] {
    return (Object.keys(errors) as Array<keyof SiuCaseDetailsFieldErrors>).map((key) => FIELD_LABELS[key]);
}

export function getSiuCaseDetailsValidationToastMessage(errors: SiuCaseDetailsFieldErrors): string {
    const labels = getSiuCaseDetailsMissingFieldLabels(errors);
    if (labels.length === 0) {
        return '';
    }
    return `Please complete the following required fields: ${labels.join(', ')}.`;
}
